export const useKilometers = (m) => {
  return (m / 1000)
}
